import { render, staticRenderFns } from "./ModalRepeatedPatients.vue?vue&type=template&id=089632e8&"
import script from "./ModalRepeatedPatients.vue?vue&type=script&lang=js&"
export * from "./ModalRepeatedPatients.vue?vue&type=script&lang=js&"
import style0 from "./ModalRepeatedPatients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports